import { useReducer, useEffect } from "react";
import energyConsumptionReducer from "./reducer";
import { fetchEnergyConsumption } from "./api";
import ACTIONS from "./actions";
import { getEnergyConsumptionDateFormat, transformEnergyConsumptionData } from "../../../../lib/utils/utility";

const initialState = {
  isLoading: false,
  isError: false,
  data: [],
};

async function getEnergyConsumptionDetails(dispatch, chargerId, timeRange, siteId) {
  const startTime = getEnergyConsumptionDateFormat(new Date(timeRange[0]));
  const endTime = getEnergyConsumptionDateFormat(new Date(timeRange[1]));
  dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_INIT });
  const energyConsumptionData = await fetchEnergyConsumption(siteId, startTime, endTime);
  if (energyConsumptionData) {
    const data = energyConsumptionData.e_c;
    let result = [];
    Object.keys(data).forEach(dateKey => {
      const innerObj = data[dateKey];
      if (innerObj[chargerId]) {
        result = [...result, ...innerObj[chargerId]];
      }
    });
    const finalResult = transformEnergyConsumptionData(result, startTime, endTime, timeRange[0], timeRange[1]);
    dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_SUCCESS, payload: finalResult });
  } else {
    dispatch({ type: ACTIONS.FETCH_ENERGY_CONSUMPTION_FAILURE });
  }
}

function useEnergyConsumptionReducer({ chargerId, timeRange, siteId }) {
  const [state, dispatch] = useReducer(energyConsumptionReducer, initialState);

  useEffect(() => {
    if (siteId && chargerId && timeRange) {
      getEnergyConsumptionDetails(dispatch, chargerId, timeRange, siteId);
    }
  }, [timeRange, chargerId, siteId]);

  return {
    state,
    dispatch,
  };
}

export default useEnergyConsumptionReducer;
